import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const submitContact = (payload) => api.post("/contact", payload).then((r) => r.data);
export const submitCareer = (payload) => api.post("/careers", payload).then((r) => r.data);
export const subscribeNewsletter = (payload) => api.post("/newsletter", payload).then((r) => r.data);
